import React from "react";

const Footer = () => {
    return <footer className="page__footer">Shopping List | CR 2020</footer>;
};

export default Footer;
